import React from 'react';
import { v4 as uuidv4 } from 'uuid';

// Components
import { WpText } from 'Wpds/components/text';

type Props = {
  description: string;
};

const MultilineDescription = ({ description }: Props) => {
  if (!description?.split('\n')) return null;
  const uuid = uuidv4();
  return (
    <>
      {description.split('\n').map((description_line, index) => (
        <WpText noMargin key={`MultilineDescription-${uuid}-${index}`}>
          {description_line}
        </WpText>
      ))}
    </>
  );
};
export default MultilineDescription;
